import React from "react";
import { DriveFileRenameOutline, ChevronRight } from "@mui/icons-material";
import { Button } from "../button/button";
import styles from "./news-section.module.css";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../routes";
import { fetchPosts, PostItem } from "../../apis/news";

export const NewsSection: React.FC = () => {
    const history = useHistory();

    const [newsData, setNewsData] = React.useState<PostItem[]>([]);

    React.useEffect(() => {
        fetchPosts(0, 4).then(({ items }) => setNewsData(items));
    }, []);

    const mainNews = newsData[0];
    const sideNews = newsData.slice(1);
    if (!mainNews) return null;

    const handleNavigate = () => {
        history.push(ROUTES.NEWS_PAGE);
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    };

    const goToNewPage = (id: number | string) => {
        history.push(`/noticias/${id}`);
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    };


    const capitalizeFirstLetter = (str: string): string => {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    return (
        <>
            <div className={styles.desktopNewsSection}>
                <section className={styles.newsSection}>
                    <div className={styles.headerContainer}>
                        <div className={styles.headerRow}>
                            <div className={styles.headerCol}>
                                <div className={styles.headerTextContainer}>
                                    <div className={styles.headerBar}></div>
                                </div>
                                <div className={styles.headerText}>
                                    <h2 className={styles.heading}>Notícias</h2>
                                    <div className={styles.subheading}>
                                        Acompanhe as últimas notícias do nosso Estado
                                    </div>
                                </div>
                            </div>
                            <div className={styles.headerColButton}>
                                <Button
                                    onClick={handleNavigate}
                                    iconComponent={
                                        <DriveFileRenameOutline className={styles.headerButtonIcon} />
                                    }
                                    text="Acessar todas"
                                    className={styles.headerButton}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles.headerDivider}></div>
                    <div className={styles.gridContainer}>
                        <div className={styles.mainNews} onClick={() => goToNewPage(mainNews.id)}>
                            <img src={mainNews.image} alt="" />
                            <div className={styles.overlay}>
                                <div className={styles.mainNewsTheme}>
                                    {mainNews.theme ? `${capitalizeFirstLetter(mainNews.theme)} | Destaque` : "Destaque"}
                                </div>
                                <div className={styles.mainNewsTitle}>{mainNews.title}</div>
                            </div>
                        </div>
                        <div className={styles.sideNews}>
                            {sideNews.map((news) => (
                                <div key={news.id} className={styles.sideNewsItem} onClick={() => goToNewPage(news.id)}>
                                    <img src={news.image} alt="" />
                                    <div className={styles.sideNewsOverlay}>
                                        <div className={styles.newsTheme}>
                                            <span className={styles.newsThemeText}>{capitalizeFirstLetter(news.theme)}</span>
                                            <span className={styles.newsTime}> há {news.time}</span>
                                        </div>
                                        <div className={styles.newsTitle}>{news.title}</div>
                                        <div className={styles.goToNews}>
                                            Acessar completa <ChevronRight />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
            <div className={styles.mobileNewsSection}>
                <div className={styles.mobileNewsHeader}>
                    <div className={styles.headerTextContainer}>
                        <div className={styles.headerBar}></div>
                        <div className={styles.headerText}>
                            <h2 className={styles.heading}>Notícias</h2>
                            <div className={styles.subheading}>
                                Acompanhe as últimas notícias do nosso Estado
                            </div>
                        </div>
                    </div>
                </div>
                <hr className={styles.mobileDivider} />
                <div
                    className={styles.mobileMain}
                    onClick={() => goToNewPage(mainNews.id)}
                >
                    <div className={styles.mobileMainNewsTheme}>
                        {mainNews.theme ? `${capitalizeFirstLetter(mainNews.theme)} | Destaque` : "Destaque"}
                    </div>
                    <div className={styles.mobileMainNewsTitle}>
                        {mainNews.title}
                    </div>
                    <img src={mainNews.image} alt="" />
                    <div className={styles.goToNewsMain}>
                        Ler notícia <ChevronRight />
                    </div>
                    <hr className={styles.mobileDividerListItems} />
                </div>
                <ul className={styles.mobileList}>
                    {sideNews.map((news, idx) => (
                        <li
                            key={news.id}
                            className={styles.mobileListItem}
                            onClick={() => goToNewPage(news.id)}
                        >
                            <img src={news.image} alt="" />
                            <div className={styles.mobileListItemText}>
                                <div className={styles.newsTheme}>
                                    <span className={styles.newsThemeText}>{capitalizeFirstLetter(news.theme)}</span>
                                    <span className={styles.newsTime}>há {news.time}</span>
                                </div>
                                <div className={styles.newsTitle}>{news.title}</div>
                                <div className={styles.goToNews}>
                                    Ler notícia <ChevronRight />
                                </div>
                            </div>
                            {idx < sideNews.length - 1 && (
                                <hr className={styles.mobileDividerListItems} />
                            )}
                        </li>
                    ))}
                </ul>
                <div className={styles.mobileButtonWrapper}>
                    <Button
                        onClick={handleNavigate}
                        iconComponent={<ChevronRight />}
                        text="Acessar todas notícias"
                        className={styles.headerButton}
                    />
                </div>
            </div>
        </>
    );
};
